import { v4 as uuidv4 } from "uuid";
import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { updateBigQueryDataByFilters } from "../../../api/postCall/updateBigQueryDataByFilters";
import {
  buildReassignCaseFieldRecord,
  type ReassignCasePayload,
} from "../../../components/modals/reassignCaseModal/reassignCaseModal";
import { FILENAME_BATCH_COLUMN } from "../../configurations/pages/pocConfiguration/utils/filenameBatchOptions";

/**
 * Bulk-reassigns pharma STP file rows via the commons BigQuery update endpoint.
 * Sends only the filename / POC fields the user selected (no row identifiers).
 *
 * @param payload - Optional filename scope, From filters, and To update values
 * @returns `true` when the update succeeds, `false` otherwise
 */
export const handleReassignCaseAssign = async (
  payload: ReassignCasePayload,
): Promise<boolean> => {
  try {
    await updateBigQueryDataByFilters({
      filters: {
        ...buildReassignCaseFieldRecord(payload.from),
        ...(payload.filename
          ? { [FILENAME_BATCH_COLUMN]: payload.filename }
          : {}),
      },
      update_data: buildReassignCaseFieldRecord(payload.to),
      request_id: uuidv4(),
    });
    return true;
  } catch (error) {
    console.error("Failed to reassign cases:", error);
    return false;
  }
};

/**
 * Runs reassignment and surfaces success/error toasts for the Pharma STP File table modal.
 *
 * @param payload - Modal selections from `ReassignCaseModal`
 * @param onSuccess - Optional callback after a successful update (e.g. table refetch)
 * @returns `true` on success, `false` when the update fails
 */
export const handleReassignCaseAssignWithToast = async (
  payload: ReassignCasePayload,
  onSuccess?: () => void,
): Promise<boolean> => {
  const succeeded = await handleReassignCaseAssign(payload);

  if (succeeded) {
    toast.success("Cases reassigned successfully.");
    onSuccess?.();
    return true;
  }

  toast.error("Failed to reassign cases. Please try again.");
  return false;
};
